export default __webpack_public_path__ + "static/media/portfolioSS.c9723693.png";